import { taxes, StsTaxes, TaxSchemeIds } from '@betgames/bg-tools';

export const getTaxSettingsBySchemeId = (schemeId?: TaxSchemeIds) => {
    if (schemeId === TaxSchemeIds.STS) {
        return new StsTaxes();
    }
    return taxes;
};
